import { render, staticRenderFns } from "./EditPopularButton.vue?vue&type=template&id=a2f9601a"
import script from "./EditPopularButton.vue?vue&type=script&lang=js"
export * from "./EditPopularButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../deps/0/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports